import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  readonly isOpen = signal(false);
  readonly selected = signal('/');

  setSignal(value: boolean): void {
    this.isOpen.set(value);
  }

  selectedMenu(menu: string): void {
    this.selected.set(menu || '/');
  }
}
